import React, { useContext } from 'react';

import CardBaseFC, { RoundNotLoadedYet } from 'components/CardBase';
import { MobileContext } from 'context';
import { PredictionCurrencySymbol } from 'components/CurrencySymbols';
import { availablePositions, LOW_PRIZE_POOL_THRESHOLD, REWARD_PRECISION_DECIMALS
} from 'const';
import { useGameDetails, useNextRound } from 'utils/Hooks';
import ThumbsUp from 'assets/art/DOGE_BETS_CIRCLE_UP.webp';
import ThumbsDown from 'assets/art/DOGE_BETS_CIRCLE_DOWN.webp';
import { ReactComponent as TextEntered } from 'assets/text/entered.svg';
import 'components/CardCurrent/index.scss';
import '../styles.scss';


function CardNextOverview(props) {
  const isMobile = useContext(MobileContext);

  const gameDetails = useGameDetails();
  const round = useNextRound();

  const rewardDecimalsToShow = REWARD_PRECISION_DECIMALS[gameDetails.wantedChain.name];

  function CheckConsistencyOf(side) {
    if (!side) throw new SyntaxError('missing required argument: side');
    else if (side != 'bear' && side != 'bull')
      throw new SyntaxError('malformed argument: side; only "bear" or "bull" values are permitted');
  }

  function UserMadeBetOnThisSide(side) {
    CheckConsistencyOf(side);

    /*
    if (side === 'bull')  // debug
      return true;        // debug
    else                  // debug
      return false;       // debug
      */

    if (props.alreadyEntered) {
      const userPosition = props.enteredPosition;
      if (userPosition === availablePositions.bull && side === 'bull')
        return true;
      else if (userPosition === availablePositions.bear && side === 'bear')
        return true;
      return false;
    } else {
      return false;
    }
  }


  function Prize() {  // UNUSED; left here for prize pool flashing logic
    const PrizePool = () => null; // dummy, to avoid compilation errors

    let output, needsToBeFlashing = false;
    if (RoundNotLoadedYet(round)) {
      output = null;
    } else {
      const round = round;
      const rewards = ((Number(round.bullAmount) + Number(round.bearAmount)) / 10 ** 18)
        .toFixed(rewardDecimalsToShow);
      const lowRewardsThreshold = LOW_PRIZE_POOL_THRESHOLD[gameDetails.wantedChain.name];
      if (rewards < lowRewardsThreshold)
        needsToBeFlashing = true;
      output = (<div>
        <div className='Separator' />
        {PrizePool(rewards, needsToBeFlashing)}
      </div>);
    }
    return output;
  }


  function EntryNotice(side) {
    if (!side) throw new SyntaxError('missing required argument: side');

    if (side === 'bear' && UserMadeBetOnThisSide(side))
      return (<TextEntered className='EntryNotice Bear' />);
    else if (side === 'bull' && UserMadeBetOnThisSide(side))
      return (<TextEntered className='EntryNotice Bull' />);
    else
      return null;
  }

  function ThumbsImageFor(position) {
    if (!position) throw new SyntaxError('missing required argument: position');
    let image = null;
    if (position === 'bear')
      image = (<img src={ThumbsDown} alt='down' width='75%' />);
    else if (position === 'bull')
      image = (<img src={ThumbsUp} alt='up' width='75%' />);
    return <div className='w-1/3 xs:w-1/3'>{image}</div>;
  }


  function BetBear() {
    return (
      <button className='ThemeButton Bear'
        disabled={props.alreadyEntered} onClick={props.BetBear}
      >
        {BetButtonFor('bear')}
      </button>
    );
  }

  function BetBull() {
    return (
      <button className='ThemeButton Bull'
        disabled={props.alreadyEntered} onClick={props.BetBull}
      >
        {BetButtonFor('bull')}
      </button>
    );
  }

  function BetButtonFor(side) {
    CheckConsistencyOf(side);
    return (<React.Fragment>
      {EntryNotice(side)}
      <div className='group flex gap-10x space-x-5 items-center'>
        {ThumbsImageFor(side)}
        <div className='w-1/2 uppercase'>
          <span className='text-base md:text-xl font-bold'>{side == 'bull' ? 'UP' : 'DOWN'}</span>
          <p className='Payout text-lg'>{Payout(side)}</p>
        </div>
      </div>
    </React.Fragment>);
  }

  function CurrencyIcon() {
    if (isMobile) {
      const rotation = DoNotRotateIfBNB();
      return (
        <div className='Currency' style={rotation}>
          <img src={gameDetails.logo} alt='coin'></img>
        </div>
      );
    } else {
      return (<div className='spacer'></div>);
    }
  }
  function DoNotRotateIfBNB() {
    if (props.predictionTickerSymbol == 'BNB') return { transform: 'rotate(+25deg)' }; // eslint-disable-line eqeqeq
    else return {};
  }

  function Payout(side) {
    let output;
    if (RoundNotLoadedYet(round)) {
      output = null;
    } else {
      const rewards = Number(round.bullAmount) + Number(round.bearAmount);
      let wantedSideTotalBet, payout;
      if (side === 'bear')
        wantedSideTotalBet = Number(round.bearAmount);
      else if (side === 'bull')
        wantedSideTotalBet = Number(round.bullAmount);
      else
        throw new SyntaxError('missing "side" argument in "Payout" function in "CardNext" class');

      if (wantedSideTotalBet === 0)
        payout = '0.00'
      else
        payout = (rewards / wantedSideTotalBet).toFixed(2);
      output = payout + 'x';
    }
    return output;
  }


  function ExpiredCard() {
    return (
      <div className='ThemeCardBase Card Next Empty'>
        <div className='white-centered-text'>
          Next Round #{round ? round.epoch : '-'}
        </div>
        <div className='Separator'/>
        {/* ExecutionNotice() */}
      </div>
    );
  }

  if (props.expired) {
    return ExpiredCard();
  } else {
    return (
      <CardBaseFC
        cardName='Next'
        round={round}
      >
        <div className='CardBody'>
          <div className='InteractiveOdds'>
            {BetBull()}

            <div className='ThemeBox FlexCenter WageringOn'>
              <p>Wagering On:</p>
              <div>
                <PredictionCurrencySymbol /></div>
            </div>
            {BetBear()}
          </div>
        </div>
      </CardBaseFC>
    );
  }
}

// finished porting, but did not try compiling


export default CardNextOverview;
